/*************************************************/
/* HEADER                                        */
/*************************************************/

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--parent';
    const menuItemParentSelector = '.menu-nav__links--list-item';
    const menuItemChildren = '.menu-nav__children';
    const activeClass = "active";
    const submenuSelector = '.menu-nav--lvl-2';
    const parentMenuEnterEvents = ['focusin', 'mouseenter'];
    const parentMenuExitEvents = ['focusout', 'mouseleave'];

    const init = () => {
        const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);

        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {
                const submenu = item.closest(parentMenuItemSelector).querySelector(submenuSelector);

                parentMenuEnterEvents.forEach(event => {
                    item.addEventListener(event, () => toggleSubMenuVisibility(submenu, false));
                });

                parentMenuExitEvents.forEach(event => {
                    item.addEventListener(event, () => toggleSubMenuVisibility(submenu, true));
                });

                const menuItemParents = document.querySelectorAll(menuItemParentSelector);
                menuItemParents.forEach(menuItem => {
                    const children = menuItem.querySelector(menuItemChildren);

                    parentMenuEnterEvents.forEach(event => {
                        menuItem.addEventListener(event, () => {
                            toggleActiveClassForChildren(document.querySelectorAll(menuItemChildren), children);
                        });
                    });

                    parentMenuExitEvents.forEach(event => {
                        item.addEventListener(event, () => {
                            if (children) {
                                children.classList.remove(activeClass);
                            }
                        });
                    });
                });
            });
        }
    };

    const toggleSubMenuVisibility = (submenu, hidden) => {
        submenu.setAttribute('aria-hidden', hidden);
    };

    const toggleActiveClassForChildren = (allChildren, currentChildren) => {
        allChildren.forEach(child => {
            child.classList.remove(activeClass);
        });

        if (currentChildren) {
            currentChildren.classList.add(activeClass);
        }
    };

    init();
}
